import { Component, Input, EventEmitter, Output } from "@angular/core";
import { moveItemInArray, CdkDragDrop } from "@angular/cdk/drag-drop";
import {
  VAIconRegistryService,
  gripVertical,
  close,
} from "@va/core-library/icons";

@Component({
  selector: "app-remove-modal-section",
  templateUrl: "./remove-modal-section.component.html",
  styleUrls: ["./remove-modal-section.component.scss"],
})
export class RemoveModalSectionComponent {
  @Input() dataToUse;
  @Input() field;
  @Input() company: string;
  @Input() maxHeight: string;
  @Output() removeData = new EventEmitter<any>();
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([gripVertical, close]);
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.dataToUse, event.previousIndex, event.currentIndex);
  }

  removeModalData(data) {
    this.removeData.emit(data);
  }
}
